import { render, staticRenderFns } from "./InfraestructuraSubTab.vue?vue&type=template&id=4beffc9a&"
import script from "./InfraestructuraSubTab.vue?vue&type=script&lang=js&"
export * from "./InfraestructuraSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports